module.exports = __webpack_public_path__ + "static/day14-c38201887d767b3bf7113ca35d8f60ea.png";